module.exports = __webpack_public_path__ + "static/media/validate_step_identify.1841ff4d.png";